import React, { useState } from 'react'
import styles from './styles.module.css'

function Descriptions ({ record }) {
  const [isExpanded, setIsExpanded] = useState(false)

  // Sort descriptions by dateSeen in descending order
  const sortedDescriptions =
    record?.descriptions?.sort((a, b) => {
      return new Date(b.dateSeen) - new Date(a.dateSeen)
    }) || []

  // Limit the display to 3 descriptions unless expanded
  const descriptionsToShow = isExpanded
    ? sortedDescriptions
    : sortedDescriptions.slice(0, 3)

  // Toggle expand/collapse state
  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <section className={styles.containerMainDescription}>
      <h2 className={styles.titleDescription}>Descriptions</h2>

      <div className={styles.containerDescription}>
        {descriptionsToShow.length > 0 ? (
          descriptionsToShow.map((description, index) => (
            <div className={styles.containerDescriptionValues} key={index}>
              <p className={styles.descriptionValueP}>{description.value}</p>
              <p className={styles.descriptionDateP}>
                {description.dateSeen
                  ? new Intl.DateTimeFormat('en-US', {
                      month: 'long',
                      day: 'numeric',
                      year: 'numeric'
                    }).format(new Date(description.dateSeen))
                  : 'N/A'}
              </p>
            </div>
          ))
        ) : (
          <span className={styles.notFound}>N/A</span>
        )}
      </div>

      {/* Show the expand button only if there are more than 3 descriptions */}
      {sortedDescriptions.length > 3 && (
        <button className={styles.expandButton} onClick={toggleExpand}>
          {isExpanded
            ? 'Show less'
            : `Expand all (${sortedDescriptions.length})`}
        </button>
      )}
    </section>
  )
}

export default Descriptions
